import React, { useEffect, useState } from 'react';
interface RSVPModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function RSVPModal({
  isOpen,
  onClose
}: RSVPModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    attendees: '1'
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Reset form when modal opens
      setIsSubmitted(false);
      setFormData({
        name: '',
        company: '',
        attendees: '1'
      });
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('RSVP submitted:', formData);
    // Show success state
    setIsSubmitted(true);
    // Close modal after 3 seconds
    setTimeout(() => {
      onClose();
    }, 3000);
  };
  const isFormValid = formData.name && formData.company && formData.attendees;
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-562">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fade-in" onClick={!isSubmitted ? onClose : undefined} data-id="element-563" />

      {/* Confetti Animation */}
      {isSubmitted && <div className="fixed inset-0 pointer-events-none z-50" data-id="element-564">
          {[...Array(50)].map((_, i) => <div key={i} className="absolute animate-confetti" style={{
        left: `${Math.random() * 100}%`,
        top: '-10px',
        width: '10px',
        height: '10px',
        backgroundColor: ['#F59E0B', '#FFFFFF', '#3B82F6', '#10B981'][Math.floor(Math.random() * 4)],
        animationDelay: `${Math.random() * 0.5}s`,
        animationDuration: `${2 + Math.random() * 2}s`,
        transform: `rotate(${Math.random() * 360}deg)`
      }} data-id="element-565" />)}
        </div>}

      {/* Modal */}
      <div className="relative w-full max-w-2xl bg-gradient-to-br from-navy via-navy-light to-navy rounded-lg shadow-2xl animate-scale-in overflow-hidden" data-id="element-566">
        {/* Close Button */}
        {!isSubmitted && <button onClick={onClose} className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-white/20 transition-colors" aria-label="Close" data-id="element-567">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-568">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-569" />
            </svg>
          </button>}

        <div className="p-6 md:p-8" data-id="element-570">
          {!isSubmitted ? <>
              <div className="text-center mb-6 md:mb-8" data-id="element-571">
                <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4" data-id="element-572">
                  RSVP to the Recruiting Breakout Session
                </h2>
                <p className="text-base md:text-lg text-blue-100" data-id="element-573">
                  Wednesday at 3pm • 45-minute in-depth breakdown
                </p>
              </div>

              <form onSubmit={handleSubmit} data-id="element-574">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg border-2 border-white/20 p-4 md:p-6 mb-6" data-id="element-575">
                  <div className="space-y-3 md:space-y-4" data-id="element-576">
                    <div data-id="element-577">
                      <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-578">
                        Your Name
                      </label>
                      <input type="text" name="name" autoComplete="name" value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} placeholder="John Smith" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-579" />
                    </div>

                    <div data-id="element-580">
                      <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-581">
                        Company Name
                      </label>
                      <input type="text" name="organization" autoComplete="organization" value={formData.company} onChange={e => setFormData({
                    ...formData,
                    company: e.target.value
                  })} placeholder="Your Company" className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white placeholder-blue-200 outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-582" />
                    </div>

                    <div data-id="element-583">
                      <label className="block text-xs md:text-sm font-semibold text-white mb-1.5 md:mb-2" data-id="element-584">
                        How Many Are Attending?
                      </label>
                      <select value={formData.attendees} onChange={e => setFormData({
                    ...formData,
                    attendees: e.target.value
                  })} className="w-full p-3 md:p-4 rounded-lg border-2 border-white/30 bg-white/5 text-white outline-none focus:border-amber transition-colors text-base md:text-lg backdrop-blur-sm" data-id="element-585">
                        <option value="1" className="bg-navy" data-id="element-586">
                          1 person
                        </option>
                        <option value="2" className="bg-navy" data-id="element-587">
                          2 people
                        </option>
                        <option value="3" className="bg-navy" data-id="element-588">
                          3 people
                        </option>
                        <option value="4" className="bg-navy" data-id="element-589">
                          4 people
                        </option>
                        <option value="5" className="bg-navy" data-id="element-590">
                          5 people
                        </option>
                        <option value="6+" className="bg-navy" data-id="element-591">
                          6+ people
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <button type="submit" disabled={!isFormValid} className="w-full py-4 md:py-5 bg-amber hover:bg-amber-dark disabled:bg-amber/50 disabled:cursor-not-allowed text-navy font-bold text-lg md:text-xl rounded-lg transition-all shadow-xl hover:scale-105 active:scale-100 disabled:hover:scale-100" data-id="element-592">
                  Confirm RSVP →
                </button>
              </form>
            </> : <div className="text-center py-12 animate-fade-in" data-id="element-593">
              <div className="mb-8" data-id="element-594">
                <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 bg-green-500 rounded-full flex items-center justify-center animate-scale-in" data-id="element-595">
                  <svg className="w-10 h-10 md:w-12 md:h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-596">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-597" />
                  </svg>
                </div>
                <h2 className="text-2xl md:text-4xl font-bold text-white mb-3" data-id="element-598">
                  You're All Set!
                </h2>
                <p className="text-base md:text-lg text-blue-100" data-id="element-599">
                  We'll see you Wednesday at 3pm
                </p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}